export const optimizedResize = (function () {
  var callbacks = []
  var running = false

  // fired on resize event
  function resize () {
    if (!running) {
      running = true
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks)
      } else {
        setTimeout(runCallbacks, 10)
      }
    }
  }

  // run the actual callbacks
  function runCallbacks () {
    callbacks.forEach(function (callback) {
      callback()
    })
    running = false
  }

  // adds callback to loop
  function addCallback (callback) {
    if (callback) {
      callbacks.push(callback)
    }
  }

  return {
    // public method to add additional callback
    add: function (callback) {
      if (!callbacks.length) {
        window.addEventListener('resize', resize)
      }
      addCallback(callback)
    }
  }
}())

export const isAdvancedUpload = function () {
  // feature detection for drag and drop:
  var div = document.createElement('div')
  return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
}



// WEBPACK FOOTER //
// ./uncommon-client/utilities/window.js